import { Component, OnDestroy, OnInit } from '@angular/core';
import { APPLICATION_SECTIONS_BUSINESS } from '../../_constants/application-sections';
import { USER_MENU } from 'base-customer';
import { Subject } from 'rxjs';
import { baseAuthSelectors, BaseCoreState, baseAuthActions, BASE_CUSTOMIZED_USERS, BaseTokenInterface } from 'base';
import { filter, map, takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';

@Component({
  selector: 'business-wrapper-component',
  templateUrl: './wrapper.component.html',
})
export class WrapperComponent implements OnInit, OnDestroy {
  sections = APPLICATION_SECTIONS_BUSINESS;
  userMenu = USER_MENU;
  customizedUsers = BASE_CUSTOMIZED_USERS;
  logo = 'assets-global/images/stazzle-business.svg';
  logoSmall = 'assets-global/images/stazzle-business-logo-small.svg';
  isCustomizedUser = false;

  private destroy$ = new Subject();

  constructor(private readonly store: Store<BaseCoreState>) {}

  ngOnInit() {
    this.getCustomizedUser();
    this.setLogo();
  }

  getCustomizedUser(): void {
    this.store
      .select(baseAuthSelectors.getUserInfo)
      .pipe(
        takeUntil(this.destroy$),
        filter((state) => !!state.ok),
        map((state) => state.data as BaseTokenInterface)
      )
      .subscribe((data) => {
        this.isCustomizedUser = this.customizedUsers.includes(data.organizationId);
        this.store.dispatch(baseAuthActions.setCustomizedUser({ payload: this.isCustomizedUser }));
      });
  }

  setLogo(): void {
    this.logo = this.isCustomizedUser
      ? 'assets-global/images/e-masters/business-logo-regular.svg'
      : 'assets-global/images/stazzle-business.svg';

    this.logoSmall = this.isCustomizedUser
      ? 'assets-global/images/e-masters/emasters-logo-small.svg'
      : 'assets-global/images/stazzle-business-logo-small.svg';
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }
}
